import { Environment } from '../../../environments/environment';

export const SourceListings = (): {
  credentials: string;
  headers: Record<string, string>;
  method: string;
  params: {
    community: string;
    fields: string;
    limit: number;
  };
  priority: string;
  reportProgress: boolean;
  transferCache: boolean;
  url: string;
} => ({
  credentials: 'include',
  headers: {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- This is the correct header name for the API request.
    'Content-Type': 'application/json',
  },
  method: 'GET',
  params: {
    community: Environment.community,
    fields:
      'address,area,baths,beds,builder,certified,communities,customFilters,date,den,description,features,furnished,floorPlan,flyerUrl,garage,geo,homesiteGeo,images,listingReps,listingStatus,mapImage,model,openToday,openTomorrow,pending,pool,price,primaryImage,saleType,series,squareFeet,turnkey,uliKey,unit,village,vls,willAccommodate,youtubeId',
    limit: 4000,
  },
  priority: 'high',
  reportProgress: true,
  transferCache: true,
  url: `${Environment.apiUrl}/listings`,
});
